module.exports = require('./helpers/bundle-url').getBundleURL('5I3eL') + "logo.c51670a8.svg";